import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-loading-component',
    templateUrl: './loading-component.component.html',
    styleUrls: ['./loading-component.component.scss'],
    standalone: false
})
export class LoadingComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
